import {Component, OnInit, HostListener, AfterViewInit} from '@angular/core';
import {scrollToElement} from '../../helpers';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit {
  mobile: Boolean = true;

  ngOnInit() {
    this.checkMobile();
  }

  ngAfterViewInit(): void {
    // document.getElementById('acuitycal-container').scrollIntoView();
    scrollToElement('#acuitycal-container', -140);
  }

  @HostListener('window:resize')
  checkMobile() {
    this.mobile = document.body.clientWidth <= 800;
  }
}



// WEBPACK FOOTER //
// /app/src/app/Components/app/app.component.ts